import Vue from "vue";
import Vuex from "vuex";
import ApiService from "../services/ApiService";
import authorization from "./authorization";
import user from "./user";


Vue.use(Vuex);


export default new Vuex.Store({
  modules: {
    authorization,
    user
  },

  state: {
    isClient: true,
    loading: false,
    appointmentSources: []
  },

  getters: {
    getUserType: state => (state.user.user ? state.user.user.type : ""),

    isLoading: state => state.loading
  },

  actions: {
    async getAppointmetSources({commit}){
      const resp = await ApiService.get('/appointment-source/');
      commit('setAppointmentSources', resp.data);
    }
  },

  mutations: {
    setUserType(state, type) {
      state.isClient = type;
    },

    setLoading(state, value) {
      state.loading = value;
    },

    setAppointmentSources(state, value) {
      state.appointmentSources = value;
    }
  }
});
